const sectionStoriesList = document.querySelectorAll('.stories-list');

sectionStoriesList.forEach(storiesList => {

  const swiperContainer = storiesList.querySelector('.swiper');
  
  const nextButton = storiesList.querySelector('.swiper-button-next');
  const prevButton = storiesList.querySelector('.swiper-button-prev');
  const swiperNavigation = storiesList.querySelector('.swiper-navigation');
  const swiperPagination = storiesList.querySelector('.swiper-pagination');

  const storiesListSwiper = new Swiper(swiperContainer, {
    pagination: {
      el: swiperPagination,
      clickable: true,
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton, 
    },
    loop: true,
    centeredSlides: true,
    slidesPerView: storiesListVideosNumberMobile,
    spaceBetween: 20,
    autoHeight: false,
    breakpoints: {
      749: {
        slidesPerView: storiesListVideosNumberDesktop,
        centeredSlides: false,
      }
    }
  });

  /* SWIPER PAGNIATION VISIBILITY */

  const storiesItem = storiesList.querySelectorAll('.story__item');

  let referenceStoriesMax;
  
  if (window.matchMedia("(max-width: 750px)").matches) {
    referenceStoriesMax = storiesListVideosNumberMobile;
  }else {
    referenceStoriesMax = storiesListVideosNumberDesktop;
  }

  if(storiesItem.length <= referenceStoriesMax){
    swiperNavigation.classList.add('hidden');
  }else{
    swiperNavigation.classList.remove('hidden');
  }

  /* Gestion des vidéos */
  const storiesVideo = storiesList.querySelectorAll('.video');

  function updateVideo(videoContainer) {

    const videoContainerId = videoContainer.id;
    const currentVideo = videoContainer.querySelector('video');
    const isActive = videoContainer.classList.contains('active');

    // Désactiver toutes les autres vidéos
    storiesVideo.forEach(container => {
      if (container.id !== videoContainerId) {
        const video = container.querySelector('video');
        container.classList.remove('active');
        video.pause();
        video.currentTime = 0;
      }
    });

    // Gérer la vidéo courante
    if (isActive) {
      currentVideo.play();
      currentVideo.loop = true;
    } else {
      currentVideo.pause();
      currentVideo.currentTime = 0;

    }
  }

  // Ajouter les écouteurs d'événements pour chaque vidéo

  storiesVideo.forEach(videoContainer => {

    const video = videoContainer.querySelector('video');

    videoContainer.addEventListener('click', () => {

      // Toggle l'état de la vidéo courante
      videoContainer.classList.toggle('active');
      updateVideo(videoContainer);

    });

    // Gestion de la fin de la vidéo
    video.addEventListener('ended', () => {
      videoContainer.classList.remove('active');
      video.currentTime = 0;
      updateVideo(videoContainer);
    });

  });
});